const initializedPixels = new Set();
const pendingPurchaseKey = (orderId) => `sh0p:pendingMetaPurchase:${orderId}`;

export function rememberPendingMetaPurchase(orderId) {
  if (typeof window === "undefined" || !orderId) return;
  try {
    window.sessionStorage.setItem(pendingPurchaseKey(orderId), "1");
  } catch {
    // Tracking storage must never interfere with checkout.
  }
}

export function hasPendingMetaPurchase(orderId) {
  if (typeof window === "undefined" || !orderId) return false;
  try {
    return window.sessionStorage.getItem(pendingPurchaseKey(orderId)) === "1";
  } catch {
    return false;
  }
}

export function clearPendingMetaPurchase(orderId) {
  if (typeof window === "undefined" || !orderId) return;
  try {
    window.sessionStorage.removeItem(pendingPurchaseKey(orderId));
  } catch {
    // The event was already sent.
  }
}

const validPixelId = (value) =>
  typeof value === "string" && /^\d+$/.test(value.trim()) ? value.trim() : null;

export function initializeMetaPixel(value) {
  const pixelId = validPixelId(value);
  if (typeof window === "undefined" || !pixelId) return null;

  if (!window.fbq) {
    const fbq = function () {
      if (fbq.callMethod) fbq.callMethod.apply(fbq, arguments);
      else fbq.queue.push(arguments);
    };
    window.fbq = fbq;
    window._fbq = fbq;
    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = "2.0";
    fbq.queue = [];

    const script = document.createElement("script");
    script.async = true;
    script.src = "https://connect.facebook.net/en_US/fbevents.js";
    document.head.appendChild(script);
  }

  if (!initializedPixels.has(pixelId)) {
    window.fbq("init", pixelId);
    initializedPixels.add(pixelId);
  }
  return pixelId;
}

export function trackMetaPageView(value) {
  const pixelId = initializeMetaPixel(value);
  if (pixelId) window.fbq("trackSingle", pixelId, "PageView");
}

export function trackMetaPurchase(value, order) {
  const pixelId = initializeMetaPixel(value);
  if (!pixelId || !order?.id || order.paymentStatus !== "complete") return;

  const storageKey = `sh0p:metaPurchase:${pixelId}:${order.id}`;
  try {
    if (window.sessionStorage.getItem(storageKey)) return;
  } catch {
    // A blocked storage API must not prevent conversion tracking.
  }

  const products = Array.isArray(order.products) ? order.products : [];
  window.fbq("trackSingle", pixelId, "Purchase", {
    value: Number(order.totals?.orderTotal) || 0,
    currency: "INR",
    content_name: products.map((product) => product.title),
    content_ids: products.map((product) => product.id),
    content_type: "product",
    num_items: products.reduce((sum, product) => sum + (Number(product.quantity) || 1), 0),
    orderId: order.id,
    contents: products.map((product) => ({
      id: product.id,
      quantity: Number(product.quantity) || 1,
    })),
  });

  try {
    window.sessionStorage.setItem(storageKey, "1");
  } catch {
    // The event was already sent.
  }
}
